export default __webpack_public_path__ + "static/media/workcafe-1.0d89142b.JPG";